export const GROWTH_UPGRADE_BUTTON_ID = 'hs-global-toolbar-growth-upgrade-button';
export const GROWTH_UPGRADE_BUTTON_RENDER_TO_ID = 'growth-upgrade-button-render-to';